import { useEffect, useState } from "react";
import { getConceptUsages } from "../../../api/snomed";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useConceptUsages = (query) => {
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalSize, setTotalSize] = useState(0);

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await getConceptUsages(query.term, query.pageSize, query.pageIndex);
                if (isSubscribed) {
                    setTotalSize(response.data.count);
                    setItems(response.data.data);
                }
            } catch (error) {
                HandleApiError(error);
            } finally {
                if (isSubscribed) setIsLoading(false);
            }
        };

        fetchData();

        return () => { isSubscribed = false; };
    }, [query.term, query.pageSize, query.pageIndex, query.reloadToken]);

    return [items, isLoading, totalSize];
};
